/*
 * @format
 *
 * Reducer to track the state of the commands being sent to the API/device via the device service
 *
 * This is fired before the debounce action, so ony needs to keep track of the last result
 */

import * as actionTypes from '../action-types';

/*
const example = {
  'home123': '1234-5678-9012-3456'
};
*/

export const initalState = {};

export default (state = initalState, action) => {
  switch (action.type) {
    case actionTypes.DEVICE_SERVICE_REQUEST_STARTED: {
      const { homeId, requestId } = action;
      return {
        ...state,
        [homeId]: requestId,
      };
    }

    case actionTypes.COMMAND_STATUS_ACK:
    case actionTypes.COMMAND_STATUS_NACK:
    case actionTypes.PENDING_CHANGE_TIMED_OUT: {
      // timeout has action.requestid, ack/nack has action.data.requestId
      const changedKey = Object.keys(state).find(
        k => state[k] === (action.requestId || action.data?.requestId),
      );

      if (changedKey) {
        const newState = {
          ...state,
        };

        delete newState[changedKey];
        return newState;
      }

      return state;
    }

    default: {
      return state;
    }
  }
};
